/**
 * AUTH
 */
import login from "@/locales/languages/es_MX/view/login";

/**
 * COMUNES
 */
import auditoria from "@/locales/languages/es_MX/view/auditoria";
import commons from "@/locales/languages/es_MX/view/commons";
import menu from "@/locales/languages/es_MX/view/menu";
import home from "@/locales/languages/es_MX/view/home";

/**
 * CATALOGOS
 */
import seguridad from "@/locales/languages/es_MX/view/seguridad";
import generales from "@/locales/languages/es_MX/view/generales";
import bitacoras from "@/locales/languages/es_MX/view/bitacoras";
import operativos from "@/locales/languages/es_MX/view/operativos";
import geograficos from "@/locales/languages/es_MX/view/geograficos";

/**
 * FILETRANSACTION
 */
import filetransaction from "@/locales/languages/es_MX/view/filetransaction";

/**
 * ERRORES
 */
import errors from "@/locales/languages/es_MX/errors";

/**
 * VALIDADOR
 */
import validator from "@/locales/languages/es_MX/validator";

/**
 * BASES
 */
import bases from "@/locales/languages/es_MX/view/bases";

/**
 * REPORTES
 */
import reportes from "@/locales/languages/es_MX/view/reportes";

export default {
  view: {
    login
    , auditoria
    , commons
    , menu
    , home
    , seguridad
    , generales
    , bitacoras
    , operativos
    , geograficos
    , filetransaction
    , bases
    , reportes
  }
  , errors
  , validator
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/index.js